import React, { useState } from "react";
import { upload_document } from "./BanijyaRenewals";
import FormButtom from "../../../../../components/common/forms/FormButtom";
import FormPayment from "../../../../../components/common/forms/FormPayment";
import { useForm } from "react-hook-form";
import axios from "axios";
import api, { url } from "../../../../../api/api";
import BusinessSearchNDetails from "../../../../../components/common/forms/BusinessSearchNDetails";
import { v4 as uuidv4 } from "uuid";
import Documents from "../../../../../components/common/forms/Documents";
import FormBranch from "../../../../../components/common/forms/FormBranch";
import { toast } from "react-toastify";
import NewFormPayment from "../../../../../components/common/forms/NewFormPayment";

export const OldBanijiya = () => {
  const { register, handleSubmit } = useForm();
  const [docsOutput, setDocsOutput] = useState([]);
  const [cmpId, setCmpId] = useState(null);

  
  const [uploadProof, setUploadProof] = useState('')

  const handleClick = (data) => {
    // data.share_holders = shareHolders
    if (cmpId === null) {
      alert("First search company");
      return;
    }
    data.documents = docsOutput;
    data.company = cmpId;
    data.amendment_type = "banijya_renewal";
    // console.log(data);

    const user = JSON.parse(localStorage.getItem("user"));

    api.post('services/company/amendments/', data)
      .then((response) => {
        toast.success("Data Registered Successfully")
        
        // let transactions = {
        //   // payment_mode: "e_wallet",
        //   amount: 2500,
        //   service_object_id: response.data.service_object_id,
        //   created_by: response.data.service_object_id,
        //   service_object_content_type: response.data.service_content_type_id,
        //   payment_proof : uploadProof,
        //   company : cmpId,
        //   transaction_type: "credit"
       
        // };

  
        // api
        // .post("/transactions/", transactions)
        // .then((response) => {
        //   toast.success("Data Registered 2 Successfully.");
        // })
        // .catch((error) => {
        //   toast.error("Error in Transaction");
        // });
      })
      .catch((error) => {
        // console.log("error", error);
        toast.error("Something went wrong")
      });
  };

  let data = [];
  upload_document.map((item, i) => {
    data.push({ id: uuidv4(), image: "", document_name: "" });
    return "";
  });

  return (
    <form>
      {/* company name and other details */}
      {/* <div className="flex-col flex md:flex-row flex-wrap">
      <div className="flex flex-wrap border-2 border-primary-blue">
        <p className="text-primary-red flex-nowrap items-center shrink-0 flex font-bold text-base">
          कम्पनी वा ब्यवसायको नाम:
        </p>
        <input className="py-2" type="search" placeholder="Search" />
      </div>
      <div className="flex flex-wrap w-fit border-2 border-primary-blue">
        <p className="text-primary-red flex items-center font-bold text-base">
          ठेगाना :
        </p>
        <input className=" " type="" placeholder="" />
      </div>
      <div className="flex flex-wrap w-fit border-2 border-primary-blue">
        <p className="text-primary-red flex items-center font-bold text-base">
          स. ब्यक्तिको नाम :
        </p>
        <input className=" " type="text" placeholder="" />
      </div>
      <div className="flex flex-wrap w-fit border-2 border-primary-blue">
        <p className="text-primary-red flex items-center font-bold text-base">
          सम्पर्क नं. :
        </p>
        <input className=" " type="text" placeholder="" />
      </div>
    </div> */}
      <BusinessSearchNDetails setCmpId={setCmpId} />
      {/* compnay name and other details close */}

      <div className="border-2 bg-pink-100 font-Laila border-primary-blue mt-3">
        <p className="text-primary-blue mt-0 text-lg font-semibold leading-10 text-center">
          वाणिज्य कार्यालयमा नविकरण सम्बन्धि काम गर्दा शेवा शुल्क वापतको रकम
          रु.८,०००।– मात्र लाग्नेछ ।
        </p>
      </div>
      <div className=" border-primary-blue font-Laila my-3">
        <div className="flex text-primary-blue mt-0 font-semibold leading-10 text-center">
          <span className=" text-primary-red mr-2">नोट :</span>
          वाणिज्य कार्यालयमा दर्ता गर्दा तिरेको राजश्वको आधारमा राजश्व रकम थप
          लाग्नेछ ।
        </div>
      </div>

      {/* upload documents open */}
      <div className="text-primary-blue font-Calistoga text-lg underline my-4">
        2. Upload Document
        <span className="text-primary-blue font-Laila underline">
          (घरेलुमा नविकरण गर्नको लागि आवश्यक पर्ने निम्न कागजपत्रहरु ग्उयिबम
          गर्नुहोस ।)
        </span>
      </div>

      <Documents
          documents_data={upload_document}
          initialState={data}
          setDocument={setDocsOutput}
        />

      {/* <table>
      <thead>
        <div>
          <div className="border-primary-blue text-primary-red border px-10 text-lg font-bold">
            S. N.
          </div>
          <div className="border-primary-blue text-primary-red border px-20 text-base font-bold sm:text-lg">
            Document Name
          </div>
          <div className="border-primary-blue text-primary-red border px-20 text-base font-bold sm:text-lg">
            Action
          </div>
          <div className="border-primary-blue text-primary-red border px-20 text-base font-bold sm:text-lg">
            Remarks
          </div>
        </div>
      </thead>
      <tbody>
        {upload_document.map((item, index) => {
          return (
            <div className="border-primary-blue border">
              <div className="text-primary-red border-primary-blue border-r  text-center font-semibold">
                {item.sn}
              </div>
              <div className="p-0">
                <p className="border-primary-blue text-primary-blue font-semibold m-0 h-[54px] w-full border-r py-3 px-3 outline-none">
                  {item.ip1}
                  <button className="bg-primary-blue text-white rounded-xl ml-3 px-2">
                    Upload
                  </button>
                </p>
              </div>
              <div className="p-0">
                <div className="border-primary-blue text-white m-0 h-[54px] w-full border-r py-3 px-3 outline-none space-x-2">
                  <button className="bg-primary-green rounded-xl px-2 ">
                    view
                  </button>
                  <button className="bg-primary-red rounded-xl px-2">
                    Delete
                  </button>
                </div>
              </div>
              <div className="p-0">
                <div className="border-primary-blue text-primary-blue font-semibold m-0 h-[54px] w-full border-r py-3 px-3 outline-none space-x-2">
                  {item.remark}
                </div>
              </div>
            </div>
          );
        })}
      </tbody>
    </table> */}
      {/* upload documents close */}
      <div className="text-primary-blue font-Calistoga  text-lg my-5 mb-6 underline">
              3. Working Branch
              <span className="text-primary-blue font-Laila underline mx-2 ">
                (तपाईले दर्ता गर्न खोज्नुभएको कम्पनी रहने ठेगाना नजिक हाम्रो कुन शाखा नजिक पर्छ छनोट गर्नुहोस् ।)
              </span>
            </div>

      <FormBranch register={register} name={"working_branch"} />
      <FormButtom />
      
      <NewFormPayment handleClick={handleClick} handleSubmit={handleSubmit}
       setUploadProof={setUploadProof}
      />
    </form>
  );
};
